var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root" }, [
    _c(
      "div",
      { staticClass: "main" },
      [
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.name))]),
          !_vm.buttonsOnly
            ? _c("div", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.description)),
              ])
            : _vm._e(),
        ]),
        !_vm.buttonsOnly
          ? _c(
              "div",
              { staticClass: "segment" },
              _vm._l(_vm.levels, function (lvl) {
                return _c(
                  "button",
                  {
                    key: lvl,
                    class: { active: _vm.level == lvl, none: lvl == "none" },
                    attrs: {
                      type: "button",
                      "data-label": _vm.$ct("module-access.levels." + lvl),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setLevel(lvl)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("module-access.levels." + lvl)) + " "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        !_vm.buttonsOnly
          ? _c(
              "w-link",
              {
                staticClass: "advanced-link",
                on: {
                  click: function ($event) {
                    _vm.advancedOpen = !_vm.advancedOpen
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.advancedOpen
                        ? _vm.$ct("module-access.less")
                        : _vm.$ct("module-access.advanced")
                    ) +
                    " "
                ),
                _c("w-fa", {
                  attrs: {
                    icon: _vm.advancedOpen ? "chevron-up" : "chevron-down",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm.buttonsOnly || _vm.advancedOpen
      ? _c(
          "div",
          { staticClass: "advanced" },
          [
            _c("div", { staticClass: "panel" }, [
              _c("div", { staticClass: "panel-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ct("module-access.visible-buttons-title", {
                      name: _vm.name,
                    })
                  )
                ),
              ]),
              _c(
                "div",
                { staticClass: "option-grid" },
                _vm._l(_vm.buttonOptions, function (option) {
                  return _c(
                    "div",
                    {
                      key: option.key,
                      staticClass: "option",
                      class: { disabled: option.disabled },
                    },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: option.value,
                          disabled: option.disabled,
                          label: option.label,
                        },
                        on: {
                          input: function ($event) {
                            return option.set($event)
                          },
                        },
                      }),
                      option.requires
                        ? _c("span", { staticClass: "hint" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$ct("module-access.requires", {
                                  level: option.requires,
                                })
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            !_vm.buttonsOnly
              ? _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-title" }, [
                    _vm._v(_vm._s(_vm.$ct("module-access.other"))),
                  ]),
                  _c("div", { staticClass: "option-grid" }, [
                    _c(
                      "div",
                      { staticClass: "option" },
                      [
                        _c("w-checkbox", {
                          attrs: { label: _vm.$ct("can-read") },
                          model: {
                            value: _vm.permissions.CanRead,
                            callback: function ($$v) {
                              _vm.$set(_vm.permissions, "CanRead", $$v)
                            },
                            expression: "permissions.CanRead",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "option" },
                      [
                        _c("w-checkbox", {
                          attrs: {
                            label: _vm.$ct("module-access.hidden-in-menu"),
                          },
                          model: {
                            value: _vm.permissions.BrowseHidden,
                            callback: function ($$v) {
                              _vm.$set(_vm.permissions, "BrowseHidden", $$v)
                            },
                            expression: "permissions.BrowseHidden",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._t("default"),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }